import Breadcrumb from 'atoms/breadcrumb';
import PartnerInfoButton from 'atoms/partner-info-button';
import PropTypes from 'prop-types';
import React from 'react';
import Title from 'atoms/title';
import Tooltip from 'atoms/tooltip';

const MAX_PARTNERS = 4;

export default function PageEstablishmentInfoNew({ allPartners, area, arrival, breadcrumb, categoryLiteral,
  city, className, combinedRating, countryCode, handleEvents, handleScroll, hasCancellationPolicy, instantBook,
  leaving, maxGuests, numberFormat, numberOfNights, partnersWithMultiLogo, partnersWithoutAvailabilityClickout,
  rooms, searchGuests, stars, t, title, titlePreposition }) {
  const partners = [...allPartners];
  const mainPartner = partners.length && partners[0].pricePerNight && partners[0].priceTotal ? partners[0] : null;
  if (mainPartner) {
    partners.shift();
  }
  const numPartners = partners.length;
  const partnersToShow = mainPartner ? (MAX_PARTNERS - 1) : MAX_PARTNERS;
  const showMaxGuests = maxGuests > 0 && maxGuests < 99;
  const showRooms = rooms > 0 && !(rooms > searchGuests);


  return (
    <div className={ `page-establishment-info-new ${className}` }>
      <div className="page-establishment-info-new__header-container">
        { breadcrumb ? <Breadcrumb breadcrumbInfo={ breadcrumb } /> : null }
        <div className="page-establishment-info-new__header-container__title">
          <h1>
            <div className="page-establishment-info-new__header-container__title__name">
              { <Title area={ area } categoryLiteral={ categoryLiteral } city={ city } t={ t } text={ title } titlePreposition={ titlePreposition } /> }
              { stars
                ? (
                  <span className="page-establishment-info-new__header-container__title__name__stars-container">
                    { Array.from({ length: stars }, (x, i) => <span key={ i } className="page-establishment-info-new__header-container__title__name__stars-container__star hundredicons-star-filled" />) }
                  </span>
                )
                : null
              }
            </div>
          </h1>
          { combinedRating > 5
            ? (
              <Tooltip
                baseClassName="page-establishment-info-new__tooltip__rating"
                position="left"
                space={ 0 }
                title={ t("Hundred Rating evaluates authentic guest experiences alongside existing ratings from other websites.") }
                tooltipX={ 0 }
              >
                <div className="page-establishment-info-new__header-container__title__average" onClick={ handleScroll.bind(this, '#establishment-page-hundred-rating') }>
                  { combinedRating > 5 && combinedRating < 10 ? combinedRating.toFixed(1) : 10 }
                </div>
              </Tooltip>
            ) : null
          }
        </div>
        <div className="page-establishment-info-new__header-container__amenities">
          <div className="page-establishment-info-new__header-container__amenities__right">
            { categoryLiteral
              ? (
                <div className="page-establishment-info-new__header-container__amenities__right__categoryLiteral">
                  {t(categoryLiteral)}
                </div>
              ) : null
            }
            { city
              ? (
                <div className="page-establishment-info-new__header-container__amenities__right__city">
                  { city }
                </div>
              ) : null
            }
          </div>
          <span className="page-establishment-info-new__header-container__amenities__separation-line" />
          <div className="page-establishment-info-new__header-container__amenities__left">
            { area
              ? (
                <span className="page-establishment-info-new__header-container__amenities__left__amenitie">
                  { `${area}m²` }
                </span>
              ) : null
            }
            { (area && showMaxGuests)
              ? (
                <span className="page-establishment-info-new__header-container__amenities__left__separator">
                  ·
                </span>
              )
              : null
            }
            { showMaxGuests
              ? (
                <span className="page-establishment-info-new__header-container__amenities__left__amenitie">
                  { `${maxGuests} ${maxGuests > 1 ? t("Guests") : t("Guest")}` }
                </span>
              ) : null
            }
            { (area || showMaxGuests) && showRooms
              ? (
                <span className="page-establishment-info-new__header-container__amenities__left__separator">
                  ·
                </span>
              )
              : null
            }
            { showRooms
              ? (
                <span className="page-establishment-info-new__header-container__amenities__left__amenitie">
                  { `${rooms} ${rooms > 1 ? t("Rooms") : t("Room")}` }
                </span>
              ) : null
            }
          </div>
          <div className="page-establishment-info-new__header-container__dates-container">
            { (arrival || leaving) && numberOfNights > 0
              ? (
                <div className="page-establishment-info-new__header-container__dates-container__right-dates">
                  { `${t("dates")}: ${arrival}` }
                  <img alt="Right arrow" className="establishment-modal__box-best-partner__dates__icon" src="/img/search/arrow-right-black.svg" />
                  { leaving }
                </div>
              )
              : (
                <div className="page-establishment-info-new__header-container__dates-container__right-dates">
                  { t("Not Available") }
                </div>
              )
            }
          </div>
        </div>
      </div>
      <div className={ `page-establishment-info-new__body-container ${mainPartner && !numPartners ? '-best-price-alone' : ''}` }>
        <div className="page-establishment-info-new__body-container__partners-container">
          { mainPartner
            && (
              <div className="page-establishment-info-new__body-container__partners-container__partner">
                <PartnerInfoButton
                  className={ className }
                  countryCode={ countryCode }
                  handleEvents={ handleEvents }
                  hasCancellationPolicy={ hasCancellationPolicy }
                  instantBook={ instantBook }
                  isAlone={ !numPartners }
                  isBestPrice={ true }
                  numberFormat={ numberFormat }
                  partner={ mainPartner }
                  partnersWithMultiLogo={ partnersWithMultiLogo }
                  t={ t }
                />
              </div>
            )
          }
          { numPartners
            ? (
              <table className={ mainPartner === null ? '-no-winner' : '' }>
                <tbody>
                  { partners.map((partner, i) => (i < partnersToShow
                    && (
                      <tr key={ i }>
                        <td key={ i }>
                          <div key={ i } className="page-establishment-info-new__body-container__partners-container__partner">
                            <PartnerInfoButton
                              className={ className }
                              countryCode={ countryCode }
                              handleEvents={ handleEvents }
                              hasCancellationPolicy={ hasCancellationPolicy }
                              instantBook={ partner.instantlyBooking }
                              isBestPrice={ false }
                              numberFormat={ numberFormat }
                              partner={ partner }
                              partnersWithMultiLogo={ partnersWithMultiLogo }
                              partnersWithoutAvailabilityClickout={ partnersWithoutAvailabilityClickout }
                              t={ t }
                            />
                          </div>
                        </td>
                      </tr>
                    )
                  ))}
                </tbody>
              </table>
            ) : null
          }
          { (numPartners >= MAX_PARTNERS)
            && (
              <div className="page-establishment-info-new__body-container__partners-container__more-oferts" onClick={ handleScroll.bind(this, '#establishment-page__grid-matching') }>
                { t("View more prices") }
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}

PageEstablishmentInfoNew.defaultProps = {
  area: 0,
  breadcrumb: null,
  categoryLiteral: '',
  className: '',
  combinedRating: 0,
  countryCode: null,
  handleEvents: () => {},
  instantBook: false,
  maxGuests: 2,
  numberFormat: n => n,
  numberOfNights: 1,
  partnersWithMultiLogo: {},
  partnersWithoutAvailabilityClickout: [],
  rooms: 1,
  searchGuests: 2,
  stars: 0,
  title: '',
  titlePreposition: '',
};

PageEstablishmentInfoNew.propTypes = {
  allPartners: PropTypes.arrayOf(PropTypes.shape({
    clickoutLink: PropTypes.string,
    favicon: PropTypes.string,
    id: PropTypes.number,
    instantlyBooking: PropTypes.bool,
    pricePerNight: PropTypes.number,
    priceTotal: PropTypes.number,
    visibleName: PropTypes.string,
  })).isRequired,
  area: PropTypes.number,
  arrival: PropTypes.string.isRequired,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  })),
  categoryLiteral: PropTypes.string,
  city: PropTypes.string.isRequired,
  className: PropTypes.string,
  combinedRating: PropTypes.number,
  countryCode: PropTypes.string,
  handleEvents: PropTypes.func,
  handleScroll: PropTypes.func.isRequired,
  hasCancellationPolicy: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  instantBook: PropTypes.bool,
  leaving: PropTypes.string.isRequired,
  maxGuests: PropTypes.number,
  numberFormat: PropTypes.func,
  numberOfNights: PropTypes.number,
  partnersWithMultiLogo: PropTypes.shape(),
  partnersWithoutAvailabilityClickout: PropTypes.arrayOf(PropTypes.number),
  rooms: PropTypes.number,
  searchGuests: PropTypes.number,
  stars: PropTypes.number,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
  titlePreposition: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
